<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="searchForm.title" placeholder="标题" clearable>
        </el-input>
      </el-form-item>
      <el-select
        v-model="searchForm.type"
        v-if="value == 0"
        label="类型"
        placeholder="请选择"
      >
        <template v-for="item in typeList">
          <el-option :label="item.typeName" :value="item.id"></el-option>
        </template>
      </el-select>
      <el-select
        v-model="value"
        label="不置顶"
        @change="getRoleList(value)"
        placeholder="请选择"
      >
        <template v-for="item in options">
          <el-option :label="item.label" :value="item.value"></el-option>
          <!--                    <el-option label="不置顶"  value="0"></el-option>-->
        </template>
      </el-select>

      <el-form-item label="创建时间">
        <el-col :span="8">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="searchForm.startTime"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="8">
          <el-date-picker
            type="date"
            placeholder="结束日期"
            v-model="searchForm.endTime"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button @click="getRoleList">搜索</el-button>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="dialogVisible = true">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
          <el-button type="danger" slot="reference" :disabled="delBtlStatu"
            >批量删除</el-button
          >
        </el-popconfirm>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column prop="title" label="标题" width="120"> </el-table-column>
      <el-table-column prop="tDescribe" label="描述" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="video" label="视频地址" show-overflow-tooltip>
        <template width="90" slot-scope="scope" v-if="scope.row.video != ''">
          <a :href="url + scope.row.video" target="_blank">{{
            url + scope.row.video
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="培训类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="orderNum" label="排序号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type" label="状态">
        <template slot-scope="scope">
          <el-tag size="small" v-if="scope.row.statu === 1" type="success"
            >上架</el-tag
          >
          <el-tag size="small" v-else-if="scope.row.statu === 0" type="danger"
            >下架</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="icon" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editHandle(scope.row.id)"
            >编辑</el-button
          >
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm
              title="这是一段内容确定删除吗？"
              @confirm="delHandle(scope.row.id)"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label="标题" prop="title" label-width="100px">
          <el-input v-model="editForm.title" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="描述" prop="tDescribe" label-width="100px">
          <el-input v-model="editForm.tDescribe" autocomplete="off"></el-input>
        </el-form-item>

        <!--                <el-form-item label="视频地址" prop="video" label-width="100px">-->
        <!--                    <el-input v-model="editForm.video" autocomplete="off"></el-input>-->
        <!--                </el-form-item>-->
        <el-form-item label="视频" prop="video" label-width="100px">
          <el-upload
            action="http://47.96.28.227:8081/hg/upload/1"
            :limit="1"
            :headers="headermsg"
            ref="upload"
            :on-success="onSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="editForm.type" placeholder="请选择上级菜单">
            <template v-for="item in selectList">
              <el-option :label="item.typeName" :value="item.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="置顶" prop="top" label-width="100px">
          <el-radio-group v-model="editForm.top">
            <el-radio :label="0">不置顶</el-radio>
            <el-radio :label="1">置顶</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="statu" label-width="100px">
          <el-radio-group v-model="editForm.statu">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序号" prop="orderNum" label-width="100px">
          <el-input-number v-model="editForm.orderNum" :min="1" label="排序号"
            >1</el-input-number
          >
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('editForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "trainingTop",
  data() {
    return {
      searchForm: {},
      delBtlStatu: true,
        typeList:[],
      total: 0,
      size: 10,
      current: 1,
      url: "http://hk-huanggang.oss-cn-hangzhou.aliyuncs.com/",
      dialogVisible: false,
      editForm: {},
      userInfo: {
        id: "",
        username: "",
        avatar: "",
        roles: "",
      },
      options: [
        {
          value: 1,
          label: "置顶",
        },
        {
          value: 0,
          label: "不置顶",
        },
      ],
      headermsg: {
        Authorization: "",
      },
      value: 0,
      tableData: [],
      stlectList: [],
      editFormRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        tDescribe: [{ required: true, message: "请输入描述", trigger: "blur" }],
        statu: [{ required: true, message: "请选择状态", trigger: "blur" }],
        video: [{ required: true, message: "请上传视频", trigger: "blur" }],
      },

      multipleSelection: [],

      permDialogVisible: false,
      permForm: {},
      defaultProps: {
        children: "children",
        label: "name",
      },
      permTreeData: [],
      selectList:[],
      video: "",
    };
  },
  created() {
    this.getRoleList();
    this.getSelectList();
    this.getType();
    this.$axios.get("/gw/sys/menu/list").then((res) => {
      this.permTreeData = res.data.data;
    });
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
    const token = localStorage.getItem("token");
    this.headermsg.Authorization = token;
  },
  methods: {
    onSuccess: function (res) {
      if (res.code == 200) {
        this.video = res.data;
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getRoleList();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getRoleList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.editForm = {};
    },
    handleClose() {
      this.resetForm("editForm");
    },
 getType() {
      this.$axios
        .get("/gw/training/type/list/0", {
          params: {
            typeName: this.searchForm.name,
            current: this.current,
            size: this.size,
          },
        })
        .then((res) => {
          this.typeList = res.data.data.records;
        });
    },
    getRoleList(pid) {
      let obj = {};
      obj.title = this.searchForm.title;
       obj.startTime = this.searchForm.startTime;
       obj.endTime = this.searchForm.endTime;
      obj.current = this.current;
      obj.size = this.size;
      if (pid != 1) {
        pid = 0;
         obj.type = this.searchForm.type;
        var url = "/gw/training/list/0";
      } else {
        var url = "/gw/training/top/0";
      }
      this.$axios
        .post(url, obj)
        .then((res) => {
          this.tableData = res.data.data.records;
          this.size = res.data.data.size;
          this.current = res.data.data.current;
          this.total = res.data.data.total;
        });
    },
    getSelectList() {
      this.$axios
        .get("/gw/training/type/list/0", {
          params: {
            // name: this.searchForm.name,
            // current: this.current,
            // size: this.size,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.selectList = res.data.data.records;
          }
        });
    },
    submitForm(formName) {
      if (this.editForm.id) {
        this.editForm.updateId = this.userInfo.id;
        this.editForm.updateName = this.userInfo.username;
      } else {
        this.editForm.createId = this.userInfo.id;
        this.editForm.createName = this.userInfo.username;
      }
      this.editForm.video = this.video;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              "/gw/training/" + (this.editForm.id ? "update" : "save"),
              this.editForm
            )
            .then((res) => {
              if (res.status == 200) {
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {
                    this.getRoleList();
                  },
                });
              } else {
                this.$message({
                  message: "创建失败",
                  type: "warning",
                });
              }
              this.dialogVisible = false;
              this.resetForm(formName);
            });
        } else {
          return false;
        }
      });
    },
    editHandle(id) {
      this.$axios.get("/gw/training/info/" + id).then((res) => {
        this.editForm = res.data.data;

        this.dialogVisible = true;
      });
    },
    delHandle(id) {
      var ids = [];

      if (id) {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((row) => {
          ids.push(row.id);
        });
      }


      this.$axios.post("/gw/training/delete", ids).then((res) => {
        this.$message({
          showClose: true,
          message: "恭喜你，操作成功",
          type: "success",
          onClose: () => {
            this.getRoleList();
          },
        });
      });
    },
    permHandle(id) {
      this.permDialogVisible = true;

      this.$axios.get("/gw/training/info/" + id).then((res) => {
        this.$refs.permTree.setCheckedKeys(res.data.data.menuIds);
        this.permForm = res.data.data;
      });
    },

    submitPermFormHandle(formName) {
      var menuIds = this.$refs.permTree.getCheckedKeys();


      this.$axios
        .post("/gw/training/perm/" + this.permForm.id, menuIds)
        .then((res) => {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.getRoleList();
              this.$router.go(0);
            },
          });
          this.permDialogVisible = false;
          this.resetForm(formName);
        });
    },
  },
};
</script>

<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>
